import { RouteName } from '@router/routeNames';

export const ROUTE_PATHS: Record<RouteName, string> = {
  [RouteName.ROOT]: '/',
  [RouteName.HOME]: '/',
  [RouteName.MAP]: '/map',
  [RouteName.PARKING_LANDING]: '/parking/:slug',
  [RouteName.PARKING_LANDING_WITH_SPOT]: '/parking/:slug/:spotName',
  [RouteName.PARKING_SEARCH_RESULTS]: '/map/parkings',
  [RouteName.PARKING_DETAILS]: '/map/parkings/parking',
  [RouteName.DEV_FEATURE_FLAGS]: '/dev/feature-flags',
  [RouteName.DEV_SPLASH_SCREEN]: '/dev/splash-screen',
  [RouteName.FILES_DOWNLOAD]: '/file/*',
  [RouteName.RESERVATION_FLOW]: '/reservation',
  [RouteName.RESERVATION_QR]: '/reservation/qr',
  [RouteName.RESERVATION_DURATION]: '/reservation/duration',
  [RouteName.RESERVATION_SUCCESS]: '/reservation/success',
  [RouteName.RESERVATION_FAILURE]: '/reservation/failure',
  [RouteName.RESERVATION_PAYMENT]: '/reservation/payment',
  [RouteName.RESERVATION_PAYMENT_STATUS_SUCCESS]: '/payment/success',
  [RouteName.RESERVATION_PAYMENT_STATUS_FAILURE]: '/payment/failure',
  [RouteName.RESERVATION_SPAN_PAYMENT_LINK]: '/reservation/span-payment/:reservationSpanId',
  [RouteName.RESERVATION_SPAN_PAYMENT_LINK_SUCCESS]: '/reservation/span-payment-result/success',
  [RouteName.RESERVATION_SPAN_PAYMENT_LINK_FAILURE]: '/reservation/span-payment-result/failure',
  [RouteName.MY_PARKINGS]: '/my-parkings',
  [RouteName.MY_SPOTS]: '/my-spots',
  [RouteName.MY_PARKING_CREATE]: '/my-parkings/create',
  [RouteName.MY_PARKING_CREATE_OWN]: '/my-parkings/create/own',
  [RouteName.MY_PARKING_CREATE_ENTRANCE_LOCATION]: '/my-parkings/create/entrance',
  [RouteName.MY_PARKING_CREATE_LOT_MODE]: '/my-parkings/create/lot-mode',
  [RouteName.MY_PARKING_CREATE_SPOTS]: '/my-parkings/create/spots',
  [RouteName.MY_PARKING_MANAGE]: '/my-parkings/:id',
  [RouteName.MY_PARKING_MANAGE_BILLING_EDIT]: '/my-parkings/:id/billing-edit',
  [RouteName.MY_PARKING_MANAGE_BILLING_SELECTION]: '/my-parkings/:id/billing-selection',
  [RouteName.MY_PARKING_MANAGE_DIMENSIONS]: '/my-parkings/:id/dimensions',
  [RouteName.MY_PARKING_MANAGE_GALLERY]: '/my-parkings/:id/gallery',
  [RouteName.MY_PARKING_MANAGE_SETTINGS]: '/my-parkings/:id/general',
  [RouteName.MY_PARKING_MANAGE_LOCATION]: '/my-parkings/:id/location',
  [RouteName.MY_PARKING_MANAGE_PRICE_RULES_CREATE]: '/my-parkings/:id/price-rules/create',
  [RouteName.MY_PARKING_MANAGE_PRICE_RULES_EDIT]: '/my-parkings/:id/price-rules/:priceRuleId',
  [RouteName.MY_PARKING_MANAGE_PRICE_RULES]: '/my-parkings/:id/price-rules',
  [RouteName.MY_PARKING_MANAGE_SIGNAGE]: '/my-parkings/:id/signage',
  [RouteName.MY_PARKING_MANAGE_SPOTS_CREATE]: '/my-parkings/:id/spots/create',
  [RouteName.MY_PARKING_MANAGE_SPOTS_EDIT]: '/my-parkings/:id/spots/:spotId',
  [RouteName.MY_PARKING_MANAGE_SPOTS]: '/my-parkings/:id/spots',
  [RouteName.MY_PARKING_MANAGE_UNAVAILABILITIES]: '/my-parkings/:id/unavailabilities',
  [RouteName.MY_PARKING_MANAGE_UNAVAILABILITY_CREATE]: '/my-parkings/:id/unavailabilities/create',
  [RouteName.MY_PARKING_MANAGE_UNAVAILABILITY_EDIT]: '/my-parkings/:id/unavailabilities/:unavailabilityId',
  [RouteName.MY_PARKING_MANAGE_VEHICLES_CREATE]: '/my-parkings/:id/vehicles/create',
  [RouteName.MY_PARKING_MANAGE_VEHICLES_EDIT]: '/my-parkings/:id/vehicles/:vehicleId',
  [RouteName.MY_PARKING_MANAGE_VEHICLES]: '/my-parkings/:id/vehicles',
  [RouteName.MY_PARKING_GATES]: '/my-parkings/:id/gates',
  [RouteName.ACCOUNT]: '/account',
  [RouteName.ACCOUNT_EDIT]: '/account/edit',
  [RouteName.ACCOUNT_VEHICLES]: '/account/vehicles',
  [RouteName.ACCOUNT_VEHICLE_DETAILS]: '/account/vehicles/:id',
  [RouteName.ACCOUNT_VEHICLE_CREATE]: '/account/vehicles/create',
  [RouteName.ACCOUNT_BILLINGS]: '/account/billings',
  [RouteName.ACCOUNT_BILLING_CREATE]: '/account/billings/create',
  [RouteName.ACCOUNT_BILLING_EDIT]: '/account/billings/:id',
  [RouteName.ACCOUNT_TICKETS]: '/account/tickets',
  [RouteName.ACCOUNT_TICKET_CREATE]: '/account/tickets/create',
  [RouteName.ACCOUNT_TICKET_CREATE_FROM_RESERVATION]: '/account/tickets/create/from-reservation/:reservationId',
  [RouteName.ACCOUNT_TICKET_SENT]: '/account/tickets/sent',
  [RouteName.ACCOUNT_TICKET_DETAILS]: '/account/tickets/:id',
  [RouteName.ACCOUNT_RESERVATIONS]: '/account/reservations',
  [RouteName.ACCOUNT_RESERVATIONS_PENDING]: '/account/reservations/pending',
  [RouteName.ACCOUNT_RESERVATION]: '/account/reservations/:id',
  [RouteName.ACCOUNT_RESERVATION_SPOT_TAKEN]: '/account/reservations/:id/spot-taken',
  [RouteName.ACCOUNT_RESERVATIONS_HISTORY]: '/account/reservations/history',
  [RouteName.ACCOUNT_PAYMENT_HISTORY]: '/account/payments/history',
  [RouteName.ACCOUNT_WALLET]: '/account/wallet',
  [RouteName.ACCOUNT_WALLET_TRANSACTIONS]: '/account/wallet/transactions',
  [RouteName.ACCOUNT_WALLET_TOP_UP]: '/account/wallet/top-up',
  [RouteName.ACCOUNT_WALLET_TOP_UP_PAYMENT]: '/account/wallet/top-up/payment',
  [RouteName.ACCOUNT_CONTACT]: '/account/contact',
  [RouteName.ACCOUNT_REGULATIONS]: '/account/regulations',
  [RouteName.ACCOUNT_PARTNER]: '/account/partner',
  [RouteName.ACCOUNT_CONTROLLER]: '/account/controller',
  [RouteName.ACCOUNT_BECOME_CONTROLLER]: '/account/become-controller',
  [RouteName.START_EARNING]: '/start-earning',
  [RouteName.AUTH_PASSWORD_RESET]: '/auth/password-reset',
  [RouteName.NOT_FOUND]: '*',
} as const;
